export default __webpack_public_path__ + "static/media/search-image.f4f33420.svg";